// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__14JiP","content":"styles_content__3Wv5A","selectAll":"styles_selectAll__w7WBA"};